import type { Space } from '@cocoonspace/sdk-js/types/space'
import { Button } from '@cocoonspace/ui/components/button'
import { Skeleton } from '@cocoonspace/ui/components/skeleton'
import { useLingui } from '@lingui/react/macro'
import { useSearchParams } from 'next/navigation'

import { useAuth } from '~/providers/auth-provider'
import { StandardPrice } from './standard-price'
import { TimeBasedPrice } from './time-based-price'

const SeePriceBtn = () => {
	const { t } = useLingui()
	const { openRegister, setAuthErrorMsg } = useAuth()

	return (
		<Button
			size='sm'
			onClick={(e) => {
				e.preventDefault()
				setAuthErrorMsg(t`Vous devez être connecté(e) pour voir le prix`)
				openRegister()
			}}
		>
			{t`Voir le prix`}
		</Button>
	)
}

export const SpaceCardPrice = ({
	space,
	className,
}: {
	space: Pick<Space, 'price' | 'prices'>
	className?: string
}) => {
	const searchParams = useSearchParams()
	const { isAuth, isLoading } = useAuth()

	if (isLoading) {
		return (
			<div className='flex flex-col items-end justify-center gap-1'>
				<Skeleton className='h-[14px] w-[50px]' />
				<Skeleton className='h-[20px] w-[80px]' />
			</div>
		)
	}

	const day = searchParams.getAll('day')
	const hasDay = day.length > 0 || !!searchParams.get('day')
	const hasStart = !!searchParams.get('start')
	const hasEnd = !!searchParams.get('end')

	if (space.price !== undefined && hasDay) {
		const type =
			hasDay && hasStart && hasEnd ? 'hour' : 'day'

		if (!isAuth) return <SeePriceBtn />

		return (
			<TimeBasedPrice
				className={className}
				space={space}
				type={type}
			/>
		)
	}

	return (
		<StandardPrice
			className={className}
			space={space}
		/>
	)
}
